
	import { defineComponent } from "vue"
	import ballSpining from '@/assets/waitingFor2.gif'

	export default defineComponent({
		setup() {
			return { ballSpining }
		},
	})
